// Стили
import './style/modal.scss'

export function Modal({modal, setModal, children, className=""}) {
    return (
        <section className={`modal medium-font center_text ${modal ? 'active' : ''} ${className}`}
                 onClick={() => setModal(false)}>
            <div className="text" onClick={e => e.stopPropagation()}>
                <button className="close_modal" onClick={() => setModal(false)}>
                    <i className="bi bi-x-lg"/>
                </button>
                {children}
            </div>
        </section>
    )
}